import { Injectable, Type } from '@angular/core';
import { FeatureService } from '../feature.service';
import { DocViewComponent } from '../../views/doc-view/doc-view.component';
import { DocMemorialViewComponent } from '../../views/custom/doc-memorial-view/doc-memorial-view.component';

@Injectable({
	providedIn: 'root'
})
export class DocViewerFactoryService {
	constructor(
		private featureService: FeatureService
	) { }

	getViewerComponent(): Type<any> {
		if (this.featureService.isFeatureEnabled('MemorialDocViewer')) {
			return DocMemorialViewComponent;
		}
		return DocViewComponent;
	}
}